<template>
  <div>
    <VTabs :value="`${currentType}`">
      <VTab
        :href="`#${invitationTypes.SHAREABLE}`"
        @click="changeInvitationType(invitationTypes.SHAREABLE)"
      >
        Shareable
      </VTab>
      <VTab
        :href="`#${invitationTypes.PERSONAL}`"
        @click="changeInvitationType(invitationTypes.PERSONAL)"
      >
        Personal
      </VTab>
      <VTab
        :href="`#${invitationTypes.EXCEL}`"
        @click="changeInvitationType(invitationTypes.EXCEL)"
      >
        Excel
      </VTab>
    </VTabs>
    <div>
      <ShareableLink v-if="currentType === invitationTypes.SHAREABLE" />
      <PersonalInvitation v-if="currentType === invitationTypes.PERSONAL" />
      <ImportFromExcel v-if="currentType === invitationTypes.EXCEL" />
    </div>
  </div>
</template>

<script>
import { candidateInvitationType } from '@/enums';
import { ref } from '@vue/composition-api';
import ShareableLink from '@/components/CandidateInvitation/ShareableLink';
import PersonalInvitation from '@/components/CandidateInvitation/PersonalInvitation';
import ImportFromExcel from '@/components/CandidateInvitation/ImportFromExcel';

export default {
  name: 'CandidateInvitation',
  components: { ImportFromExcel, PersonalInvitation, ShareableLink },
  setup() {
    const currentType = ref(localStorage.getItem('chosenInvitationType') || candidateInvitationType.SHAREABLE);
    const invitationTypes = ref(candidateInvitationType);
    function changeInvitationType(invitationType) {
      if (currentType.value !== invitationType) {
        localStorage.setItem('chosenInvitationType', invitationType);
        currentType.value = invitationType;
      }
    }

    return {
      currentType,
      changeInvitationType,
      invitationTypes,
    };
  },
};
</script>

<style scoped>

</style>
